<template>
  <i class="inline-svg" v-html="getIcon(id)" @click="$emit('click')"/>
</template>

<script>
import icons from './icons';

export default {
  props: {
    id: {
      type: String,
    },
  },
  methods: {
    getIcon(id) {
      const icon = icons[id];
      return icon;
    },
  },
};
</script>

<style lang="scss">
.inline-svg {
  align-items: center;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  display: inline-block;
  svg {
    display: block;
    fill: currentColor;
    height: 1em;
    width: 1em;
  }
}
</style>
